import { mutatorAction } from 'satcheljs';
import type { SonoraViewState } from 'owa-editor-sonora-types';

export const showActionsPanel = mutatorAction('showActionsPanel', (viewState: SonoraViewState) => {
    viewState.isClassicAttachmentActionPanelOpen = true;
});

export const hideActionsPanel = mutatorAction('hideActionsPanel', (viewState: SonoraViewState) => {
    viewState.isClassicAttachmentActionPanelOpen = false;
});
